export const BRANCHES_MODEL = {
  ID: 'id',
  NAME: 'branch_name',
  REPO_NAME: 'repository_name',
  REPO_ID: 'repository_id',
  STATE: 'state',
  CONTRIBUTOR_IDS: 'contributors',
  PR: {
    URL: 'pull_request.html_url',
    ISSUER_ID: 'pull_request.issuer_id'
  }
};

export const BRANCHES_TABLE_MODEL = {
  NAME_CELL: 'name_cell',
  REPOS_CELL: 'repos_cell',
  AUTHORS_CELL: 'authors_cell',
  STATE_CELL: 'state_cell',
  METRIC_VALUE_CELL: 'metric_value_cell',
  ACCOUNTED_CYCLE_TIME_VALUE_CELL: 'accounted_cycle_time_value_cell',
  PR_ISSUER_CELL: 'pr_issuer_cell'
};
